<template>
    <div class="service" v-if="list.service && list.service.length">
        <div class="flex">
            <template v-for="(item, i) in list.service" >
                <div :class="item.filename ? '' : 'noAvtive'" class="sborderLine" :key="i">
                    <a :href="item.filename ? item.filename : ''"  class="s1" target="_blank">
                        <span>{{item.name}}</span>
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "service",
    props: ['list']
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.service{
    /* border-top: 1px solid #000;
    border-left: 1px solid #000; */
    width: 100%;
    @mixin sborderLine{
        width: 100%;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
    }
    .sborderLineNo4{
        @include sborderLine;
    }
    .sborderLine{
       @include sborderLine;
        &:hover{
            background-color: #000000;
            .s1{
                background-position: left -220px;
            }
            .s2{
                background-position: -127px -220px;
            }
            .s3{
                background-position: left -330px;
            }
        }
    }
    a{
        display: block;
        width: 128px;
        height: 110px;
        text-align: center;
        float: left;
        background: url(../../../assets/imgs/old/ser.png) no-repeat;
        // margin-left: 20px;
        span{
            display: inline-block;
            margin-top: 80px;
            color: #fff;
            background: #000;
            font: normal 14px/15px "微软雅黑";
        }
        &.no4 span{
            background: #7f7f7f;
        }
    }
    .s1{
        background-position: left top;
    }
    .s2{
        background-position: -127px top;
    }
    .s3{
        background-position: left -110px;
    }
    .no4{
        background-position: -127px -550px;
    }
}
.noAvtive {
    opacity: .2;
    cursor: not-allowed;
    pointer-events: none;
    &:hover {
        background-color: #fff;
    }
}
.flex {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .sborderLine {
        width: 120px !important;
        border: 1px solid #000;
    }
}
</style>